import React from 'react';
import { getThemeSettingsVariables } from '../Global/commonFunctions';
import { TopbarWrapper } from '../Topbar/topbar.style';

const themeSettings = getThemeSettingsVariables();

const AuditeeTopbar = () => {
    return (
        <TopbarWrapper
            topbarBg={themeSettings.topbarBg}
            iconColor={themeSettings.topbarIconColor}
            selectedIconBg={themeSettings.topbarSelectedIconBg}
            badgeTextColor={themeSettings.badgeTextColor}
            badgeBg={themeSettings.notificationBadgeBg}
            themeColor={themeSettings.themeColor}
            themeHoverTextColor={themeSettings.themeHoverTextColor}
        >
            <div className="menu-icon">
                <span className="material-icons">menu</span>
            </div>
            <div className="spacer"></div>
            <div className="header-right">
                <div className="info-header">
                    <div className="info-header-wrapper">
                        <div className="ams-logo">
                            <img src="/assets/images/sameeksha.png" alt="" />
                        </div>
                    </div>
                </div>
            </div>
        </TopbarWrapper>
    );
}

export default AuditeeTopbar;
